import { faChevronDoubleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button, Grid, Typography
} from '@mui/material';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import shortid from 'shortid';
import { buildDefaultAndTraineeAnswers } from '../../QuizHelper';

const RatingQuestion = observer(({ currentQuestionData, isReadOnlyQuestion }) => {
  const { isAnswered } = currentQuestionData;

  const { examinationStore } = useStores();

  const { currentPage } = examinationStore;

  const [defaultAnswers, setDefaultAnswers] = useState({});
  const [ratingValues, setRatingValues] = useState([]);
  const [currentValue, setCurrentValue] = useState();

  const buildAnswers = useCallback(() => {
    setDefaultAnswers(buildDefaultAndTraineeAnswers(currentQuestionData));
  }, [currentQuestionData]);

  const buildRatingValues = useCallback(() => {
    const values = [];
    for (let i = defaultAnswers.minValue; i <= defaultAnswers.maxValue; i++) {
      values.push(i);
    }
    setRatingValues(values);
    setCurrentValue(defaultAnswers.answeredValue);
  }, [defaultAnswers]);

  useEffect(() => {
    buildRatingValues();
  }, [buildRatingValues]);

  useEffect(() => {
    buildAnswers();
  }, [buildAnswers]);

  const handleRadioChange = useCallback((e, ratingVal) => {
    if (isAnswered) {
      e.preventDefault();
    } else {
      setCurrentValue(ratingVal);
      examinationStore.setTraineeAnswers(currentPage, currentQuestionData, ratingVal);
    }
  }, [currentPage, currentQuestionData, examinationStore, isAnswered]);

  if (ratingValues.length === 0) return null;

  return (
    <Grid
      alignItems="flex-start"
      container
      direction="column"
      spacing={2}
      style={{ margin: '10px 0px' }}
    >
      <Grid item>
        <Grid alignItems="center" className="pdf-export__content__question--print-inline" container spacing={2}>
          <Grid item>
            <Typography>
              <strong>
                {`${ratingValues[0]}: ${defaultAnswers.minValueLabel}`}
              </strong>
            </Typography>
          </Grid>
          <Grid item>
            <FontAwesomeIcon icon={faChevronDoubleRight} />
          </Grid>
          <Grid item>
            <Typography>
              <strong>
                {`${ratingValues[ratingValues.length - 1]}: ${defaultAnswers.maxValueLabel}`}
              </strong>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid className="vertical-margin" item>
        <Grid alignItems="center" className="pdf-export__content__question--print-inline" container direction="row" spacing={1}>
          {ratingValues && ratingValues.map(ratingValue => (
            <Grid item key={shortid.generate()}>
              <Button
                color={currentValue === ratingValue ? 'primary' : 'secondary'}
                disabled={currentValue !== ratingValue && isReadOnlyQuestion}
                id="quiz-validate-btn"
                style={{ minWidth: '40px', fontSize: '1.6rem' }}
                variant="contained"
                // eslint-disable-next-line react/jsx-no-bind
                onClick={e => handleRadioChange(e, ratingValue)}
              >
                {ratingValue}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
});

export default RatingQuestion;

RatingQuestion.propTypes = {
  currentQuestionData: PropTypes.shape({}),
  withCorrection: PropTypes.bool.isRequired,
  isReadOnlyQuestion: PropTypes.bool.isRequired
};

RatingQuestion.defaultProps = {
  currentQuestionData: {}
};
